// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Ys86i","col":"Table_col__nNyNK","fulfillmentStatus":"Table_fulfillmentStatus__1mswl","emailCol":"Table_emailCol__27lcG"};